import { createBrowserRouter } from "react-router";
import { LayoutHome } from "./pages/home/Layout";
import App from "./App";
import { PaymentConfirmed } from "./pages/payment-confirmed";
import { Support } from "./pages/support";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <LayoutHome />,
    children: [
      {
        path: "/",
        element: <App />,
      },
    ],
  },
  {
    path: "/payment-confirmed",
    element: <PaymentConfirmed />,
  },
  {
    path: "/suporte/:companyId",
    element: <Support />,
  },
]);
